<template>
	<div>
		<div class="section-description is-medium">
			<slot />
		</div>
		<div class="items">
			<AppInput
				color="none"
				size="full"
				style="width:100%"
				type="text"
				:value="value"
				readonly
			/>
			<AppButton
				size="flex"
				color="outline-light"
				item="icon"
				class="button"
				@click="onCopy"
			>
				<img
					src="@/assets/copy.png"
					alt="copy"
				>
				Copy
			</AppButton>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LinkCopyInput',

	props: {
		value: {
			type: String,
			default: '',
		},
	},

	methods: {
		onCopy() {
			this.$copyText(this.value).then(
				(success) => {
					this.$notify({
						duration: 6000,
						type: 'info',
						title: '',
						text: `You copied the shortlink ${success.text}`,
					});
				},
				() => {
					this.$notify({
						duration: 6000,
						type: 'error',
						title: 'FAILED',
						text: 'An error has occurred. Please contact support or copy the link manually.',
					});
				},
			);
		},
	},
};
</script>

<style lang="scss" scoped>
.items {
	display: flex;
	justify-content: space-between;
	align-items: center;
	border-bottom: 2px solid $color-accent-400;
	transition: all 275ms ease-in-out;
	cursor: text;

	&:hover {
		border-bottom: 2px solid $color-accent-300;
	}
}

.section-description {
	font-size: $size-7;
	font-weight: $fontWeight-semibold;
	color: $color-accent-200;
	margin-top: $gap-2;
	margin-bottom: $gap-05;
}

.button {
	img {
		width: 15px;
	}
}
</style>
